import { useEffect } from "react";
import { version } from "uuid";
import { useParams, useNavigate } from "react-router-dom";
import LoadingSpinner from "../shared-components/LoadingSpinner";

const ReportResolver = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const uuidVersion = version(id ?? "");
    if (uuidVersion === 1) {
      navigate(`/reports/legacy/${id}/summary`);
    }
    if (uuidVersion === 4) {
      navigate(`/reports/${id}/summary`);
    }
  }, [id, navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      <LoadingSpinner />
    </div>
  );
};

export default ReportResolver;
